/* External dependencies */
import { Action } from 'redux';

/* Local dependencies */
import { User } from '../../../users/types';
import { AuthSession } from 'aws-amplify/auth';

export enum GetUserActionTypes {
  GET_USER_REQUEST = 'GET_USER_REQUEST',
  GET_USER_SUCCESS = 'GET_USER_SUCCESS',
  GET_USER_ERROR = 'GET_USER_ERROR',
}

export interface GetUserRequest extends Action<GetUserActionTypes.GET_USER_REQUEST> {
  type: GetUserActionTypes.GET_USER_REQUEST;
  session: AuthSession
  [key: string]: any;
}

export interface GetUserSuccess extends Action<GetUserActionTypes.GET_USER_SUCCESS> {
  type: GetUserActionTypes.GET_USER_SUCCESS;
  payload: User;
  [key: string]: any;
}

export interface GetUserError extends Action<'GET_USER_ERROR'> {
  type: 'GET_USER_ERROR';
  error: Error;
}

export type GetUserActions = GetUserRequest | GetUserSuccess | GetUserError;

export function getUserRequestAction(session: AuthSession): GetUserRequest {
  return {
    type: GetUserActionTypes.GET_USER_REQUEST,
    session,
  };
}

export function getUserRequestActionWihtId(id: string) {
  return {
    type: GetUserActionTypes.GET_USER_REQUEST,
    id,
  };
}

export function getUserSuccessAction(user: User, session: AuthSession): GetUserSuccess {
  console.log('getUserSuccessAction', user);
  return {
    type: GetUserActionTypes.GET_USER_SUCCESS,
    payload: user,
    session,
  };
}
